import {COLORS} from './colors';

// hex (#RRGGBB / #RGB) → "R G B" для rgb(var(--x) / alpha).
function rgbChannels(hex) {
    let h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    const n = parseInt(h, 16);
    return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

// Прокидывает палитру из colors.js в CSS-переменные --c-* на :root,
// чтобы её использовали стили формы создания в index.css.
// colors.js — единственный источник правды; эти переменные перекрывают
// статические фоллбэки из index.css.
export function applyTheme(root = document.documentElement) {
    const c = COLORS;
    const set = (k, v) => root.style.setProperty(k, v);

    set('--c-primary', c.primary);
    set('--c-primary-hover', c.primaryHover);
    set('--c-primary-rgb', rgbChannels(c.primary));
    set('--c-secondary', c.secondary);
    set('--c-accent', c.accent);
    set('--c-bg', c.bg);
    set('--c-card', c.card);
    set('--c-ink', c.ink);
    set('--c-ink-soft', c.inkSoft);
    set('--c-muted', c.muted);
    set('--c-line', c.border);
    set('--c-glow', c.glow);
    set('--c-clouds', c.clouds);
    set('--c-success', c.success);
    set('--c-error', c.error);
    set('--c-info', c.info);
    set('--c-primary-tint', c.primaryTint);
    set('--c-primary-tint-text', c.primaryTintText);
    set('--c-cta-from', c.gradients.cta[0]);
    set('--c-cta-to', c.gradients.cta[1]);
}
